export default __webpack_public_path__ + "static/media/phone.36cbbf2a.png";